$(function () {
  $('#products-head .ctrl').on('click', function () {
    $(this).addClass('active').siblings().removeClass('active');
    let index = $('#products-head .ctrl').index($(this));
    let g = $('#products-head g')
    g.removeClass('active').eq(index).addClass('active');
  })
})